import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMarker2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconMarker2"><Path d="M17.9805 9.06641L21.4141 12.5L11.5 22.4141L8.06641 18.9805L7.42871 15.1572L14.1572 8.42871L17.9805 9.06641Z" fill="currentColor"/><Path d="M12.9141 7.5L6.5 13.9141L3.89258 11.3066L6.45801 1.04395L12.9141 7.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMarker2;
